import Routes from "./routes-components/Routes"

function App() {
  return <Routes></Routes>
}

export default App
